import { FC, Fragment, useState } from "react";
import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useIntl } from "react-intl";

import { ITrainMechanism } from "../../interfaces";

interface IRow {
  row: ITrainMechanism;
}

export const Row: FC<IRow> = props => {
  const { row } = props;
  const [open, setOpen] = useState(true);

  const { formatMessage } = useIntl();
  const headersId = "pages.scheme.trainScheme.details.headers";

  return (
    <Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "0px", borderRight: "1px solid #EBEBF7" } }}>
        <TableCell
          sx={{
            maxWidth: 48,
            minWidth: 48,
            width: 48,
            p: 0,
            background: "#FAFAFF",
            textAlign: "center",
            verticalAlign: "center",
          }}
          align="center"
        >
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ width: "32%" }}>
          <Typography fontSize={15} fontWeight={500} lineHeight="16px" color="#363846">
            {row.name}
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ width: "32%" }}>
          <Typography fontSize={15} fontWeight={500} lineHeight="16px" color="#363846">
            {row.standardSize}
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ width: "32%" }}>
          <Typography fontSize={15} fontWeight={500} lineHeight="16px" color="#363846">
            {row.description}
          </Typography>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0 }}>
              <Table aria-label="components">
                <TableHead>
                  <TableRow sx={{ "& > *": { background: "#FAFAFF", borderRight: "1px solid #EBEBF7" } }}>
                    <TableCell sx={{ maxWidth: 48, minWidth: 48, width: 48 }} />
                    <TableCell component="th" scope="row" sx={{ width: "32%" }}>
                      <Typography fontSize={15} fontWeight={500} lineHeight="16px" color="#363846">
                        {formatMessage({ id: `${headersId}.component` })}
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row" sx={{ width: "32%" }}>
                      <Typography fontSize={15} fontWeight={500} lineHeight="16px" color="#363846">
                        {formatMessage({ id: `${headersId}.standardSize` })}
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row" sx={{ width: "32%" }}>
                      <Typography fontSize={15} fontWeight={500} lineHeight="16px" color="#363846">
                        {formatMessage({ id: `${headersId}.description` })}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.components.map(({ id, name, description, standardSize }) => (
                    <TableRow key={id} sx={{ "& > *": { borderRight: "1px solid #EBEBF7" } }}>
                      <TableCell component="th" scope="row" />
                      <TableCell>{name}</TableCell>
                      <TableCell>{description}</TableCell>
                      <TableCell>{standardSize}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};
